/** Id sintético para coluna de negociações cuja etapa não pertence ao funil selecionado (ex.: busca org-wide). */
export const KANBAN_OTHER_FUNNEL_STAGE_ID = '__other_funnels__';
